import { createAction } from '@reduxjs/toolkit';
import { SignalingEventPayload } from 'services/signaling';
import { SignalingWhiteboardPayload } from 'features/layout/features/content/types';
import { WhiteboardSettingKey } from 'utils/whiteboard/settings';
import {
  ChangeWhiteboardMode,
  PrivateOpenedWhiteboardsReceived,
  RejectedWhiteboardData,
  WhiteboardModeChanged,
} from './types';

export const fileUploadPrepared = createAction('whiteboard/fileUploadPrepared');
export const signalingWhiteboardDataReceived = createAction<
  SignalingEventPayload<SignalingWhiteboardPayload>
>('signaling/whiteboardDataReceived');
export const signalingWhiteboardDataRequestRejected = createAction<RejectedWhiteboardData>(
  'signaling/whiteboardDataRequestRejected'
);
export const requestWhiteboardData = createAction<string>('requestWhiteboardData');

export const whiteboardModeChanged = createAction<ChangeWhiteboardMode>(
  'contentLibrary/whiteboardModeChanged'
);
export const signalingWhiteboardModeChanged = createAction<WhiteboardModeChanged>(
  'signaling/whiteboard/modeChanged'
);
export const signalingPrivateOpenedWhiteboardsReceived =
  createAction<PrivateOpenedWhiteboardsReceived>(
    'signaling/whiteboard/privateOpenedWhiteboardsReceived'
  );

export const whiteboardSettingPushed = createAction<{
  key: WhiteboardSettingKey;
  value: string;
}>('whiteboard/settingPushed');
